import { styled } from '@mui/material/styles'

const Main = styled('main')`
  display: grid;
  place-items: center;
  grid-template-rows: 1fr;
  height: 100%;
`

export { Main }
